// Routes //////////////////////////////////////////////////////////////////

export const MarketWatchRoute = (): string => `/watchlist/market-watch`;
export const ClientWatchRoute = (): string => `/watchlist/client-watch`;
export const SecurityManagementRoute = (id: number): string =>
  `/watchlist/search/?id=${id}`;

// API //////////////////////////////////////////////////////////////////
export const PreferencesUrl = (): string =>
  '/api/v1/market_watch/watchlist_preferences/';
export const WatchlistsUrl = (): string => `/api/v1/market_watch/watchlist/`;
export const WatchlistUrl = (watchlistId: number): string =>
  `/api/v1/market_watch/watchlist/${watchlistId}/`;

export const MarketWatchInitialDataUrl = (): string =>
  `/api/v1/market_watch/watchlist/all/`;

export const MarketWatchDataUrl = (): string =>
  `/api/v1/data_export/codal_watch/`;

// todo: update this when backend api be ready
export const MarketWatchFilterUrl = (): string =>
  `/api/v1/data_export/codal_watch/filter/`;

export const MarketWatchInitialFilterUrl = (): string =>
  `/api/v1/data_export/codal_watch/initial_filter/`;

export const MarketWatchSocket = (): string => '/ws/v1/market_watch/';
